import React, { useState, useEffect } from 'react';
import DataGrid from '../../../../../components/DataGrid/DataGrid';
import { localText } from '../../../../../langs/fa/data-grid';
import moment from 'moment-jalaali';
import { formatNumber } from 'fns';
import { useHistory } from 'react-router-dom';
import { useCalculation } from 'useStores/useCalculation';
import { useMainStore } from 'useStores/useMainStore';
import { __ } from 'utils/i18n';

const List = () => {
  const history = useHistory();
  const [customer, setCustomer] = useState(null);
  const [customerDialog, setCustomerDialog] = useState(false);
  const [orderSelected, setOrderSelected] = useState(null);
  // zustand
  const limit = useMainStore((state) => state.limit);
  const previusePage = useCalculation((state) => state.basePrice.previusePage);
  const changePage = useCalculation((state) => state.changePreviusePage);
  const previuseOrders = useCalculation(
    (state) => state.basePrice.previuseOrders
  );
  const progress = useCalculation((state) => state.filters.progress);
  const origin = useCalculation((state) => state.filters.origin);
  const destination = useCalculation((state) => state.filters.destination);
  const fleetOptions = useCalculation((state) => state.filters.fleetOptions);
  const fromDate = useCalculation((state) => state.filters.fromDate);
  const toDate = useCalculation((state) => state.filters.toDate);
  const averagePrice = useCalculation(
    (state) => state?.basePrice.previuseOrders.previuseOrdersAvgPrice
  );

  const columns = [
    {
      field: 'operator',
      headerName: 'اپراتور',
      width: 100,
      renderCell: ({ value: { creator } }) =>
        `${creator.firstName} ${creator.lastName}`,
    },
    {
      field: 'loadingDate',
      headerName: 'تاریخ',
      width: 100,
      renderCell: ({ value }) => moment(value.date).format('jYY/jMM/jDD'),
    },
    {
      field: 'origin',
      headerName: 'مبدا',
      width: 100,
      renderCell: ({ value: { origin } }) => origin.title,
    },
    {
      field: 'fleetOptions',
      headerName: 'نوع ناوگان',
      flex: 1,
      renderCell: ({ value: { fleetOptions } }) =>
        fleetOptions.map((f) => `${f.fleet.title}(${f.title})`).join('، '),
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 100,
      renderCell: ({ value: { destination } }) => destination.title,
    },
    {
      field: 'cargoType',
      headerName: 'ماهیت بار',
      width: 150,
      renderCell: ({ value }) =>
        `${__(value.cargoType[0])} ${
          value.cargoType?.[1] ? __(value.cargoType?.[1]) : ''
        }`,
    },
    {
      field: 'basePrice',
      headerName: 'کرایه حمل',
      flex: 1,
      renderCell: ({ value: { basePrice } }) => formatNumber(basePrice),
    },
  ];

  const handleSelectRow = (selection) => {
    history.push({
      pathname: '/protected/admin/calculations/addBasePrice',
      state: JSON.stringify({
        origin,
        destination,
        fleetOptions,
        date: selection.value.date,
        basePrice: selection.value.basePrice,
        cargoType: selection.value.cargoType,
      }),
    });
    // window.history.pushState(
    //   {
    //     origin,
    //     destination,
    //     fleetOptions,
    //     fromDate,
    //     toDate,
    //     basePrice: selection.value.basePrice,
    //     cargoType: selection.value.cargoType,
    //   },
    //   'title',
    //   '/protected/admin/calculations/addBasePrice'
    // );
  };
  const handlePageChange = (page) => {
    changePage(page);
  };
  const handleAverageClicked = () => {
    const order = {
      basePrice: averagePrice * 1,
    };
    setOrderSelected(order);
    setCustomerDialog(true);
  };

  useEffect(() => {
    if (orderSelected && customer && !customerDialog) {
      history.push(`/protected/admin/orders/add`, {
        order: { ...orderSelected, customer },
      });
    }
  }, [orderSelected, customer, customerDialog]);

  return (
    <div style={{ height: 300, position: 'relative' }}>
      <DataGrid
        rows={
          previuseOrders?.docs?.map
            ? previuseOrders.docs.map((order) => ({
                id: order._id,
                operator: order,
                loadingDate: order,
                origin: order,
                fleetOptions: order,
                destination: order,
                cargoType: order,
                basePrice: order,
              }))
            : []
        }
        columns={columns}
        localeText={localText}
        pageSize={limit}
        rowCount={previuseOrders?.totalDocs || 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={progress}
        disableMultipleSelection
        density="compact"
        onCellClick={handleSelectRow}
      />
      <div
        style={{
          position: 'absolute',
          bottom: 15,
          right: 15,
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gridGap: 10,
        }}
      >
        <div
          style={{
            fontSize: 20,
            padding: '5px 15px',
            border: '1px solid #673ab7',
            background: '#b39ddb',
            cursor: averagePrice ? 'pointer' : 'default',
          }}
          onClick={averagePrice ? handleAverageClicked : null}
        >
          میانگین سیستم: <strong>{formatNumber(averagePrice || 0)}</strong>{' '}
          تومان
        </div>
      </div>
    </div>
  );
};

export default React.memo(List);
